export const addPrimarySuffix = (s: string, backgroundColor?: string) =>
    `${s}${backgroundColor === 'onyx' ? '-onyx' : ''}`
